export const TERMS_SKIP_KEY = "maf_terms_acceptance_skipped";
const TERMS_ACCEPTED_KEY = "maf_terms_accepted";
// Salesforce sync can lag behind the accept call. After this window the API
// value wins again, so an unchecked box in Salesforce reopens the modal.
const ACCEPTED_TTL_MS = 24 * 60 * 60 * 1000;

function acceptedKey(username) {
  return `${TERMS_ACCEPTED_KEY}:${(username || "").toLowerCase()}`;
}

export function rememberTermsAccepted(username) {
  if (!username) return;
  try {
    localStorage.setItem(acceptedKey(username), String(Date.now()));
  } catch (error) {
    // Blocked storage only means the modal can reappear until sync finishes.
  }
}

export function wasTermsAcceptedRecently(username) {
  if (!username) return false;
  try {
    const savedAt = Number(localStorage.getItem(acceptedKey(username)));
    if (!savedAt) return false;
    if (Date.now() - savedAt < ACCEPTED_TTL_MS) return true;
    localStorage.removeItem(acceptedKey(username));
  } catch (error) {
    // Treat unreadable storage as no local acceptance.
  }
  return false;
}

export function forgetTermsAccepted(username) {
  if (!username) return;
  try {
    localStorage.removeItem(acceptedKey(username));
  } catch (error) {
    // Nothing to clear.
  }
}

export function hasAcceptedTerms(value) {
  if (value === true || value === 1) return true;
  if (typeof value !== "string") return false;
  return ["1", "t", "true", "yes", "on"].includes(value.trim().toLowerCase());
}

export function wasTermsSkipped() {
  try {
    return sessionStorage.getItem(TERMS_SKIP_KEY) === "1";
  } catch (error) {
    return false;
  }
}

export function skipTermsForSession() {
  try {
    sessionStorage.setItem(TERMS_SKIP_KEY, "1");
  } catch (error) {
    // Private browsing can block session storage. The modal stays available.
  }
}

export function clearTermsSkip() {
  try {
    sessionStorage.removeItem(TERMS_SKIP_KEY);
  } catch (error) {
    // Ignore storage failures so login and logout still complete.
  }
}
